import styled from 'styled-components';

export const TranscriptionWrapper = styled.div`
    align-items: center;
    display: flex;
    margin-left: 24px;
`;
